export default __webpack_public_path__ + "static/media/app-store-download.9722c557.png";